var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("database-management", {
    attrs: {
      headings: _vm.headings,
      entries: _vm.entries,
      loading: _vm.loading,
      sort: _vm.sort,
      "sort-dir": _vm.sortDir,
      "allow-create": false,
    },
    on: {
      showModal: (id) => {
        _vm.selectedEntryId = id
        _vm.showModal()
      },
      updateSort: (key) => {
        _vm.updateSort(key)
      },
    },
    scopedSlots: _vm._u([
      {
        key: "heading",
        fn: function () {
          return [_vm._v("Region Management")]
        },
        proxy: true,
      },
      {
        key: "list",
        fn: function () {
          return _vm._l(_vm.sortedEntries, function (region) {
            return _c("region-management-list-item", {
              key: region.id,
              attrs: { region: region },
              on: {
                edit: (id) => {
                  _vm.selectedEntryId = id
                  _vm.showModal()
                },
              },
            })
          })
        },
        proxy: true,
      },
      {
        key: "modal",
        fn: function () {
          return [
            _c("region-management-modal", {
              ref: "modal",
              attrs: {
                region:
                  _vm.selectedEntryIndex !== -1
                    ? _vm.entries[_vm.selectedEntryIndex]
                    : _vm.defaultEntry,
              },
              on: {
                update: (region) => {
                  _vm.update(region)
                },
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }